/** A matched transport reply is not proof that a setting was applied.
 * Recognize the YG-T11 result tokens observed on the device, including FAILD.
 * Unknown text stays unconfirmed; do not infer success from an echo or "OK".
 * @param {string|null|undefined} text
 * @param {string} fallback
 */
export function gt06CommandStatus(text, fallback = 'response_received') {
  const reply = typeof text === 'string' ? text.trim() : '';
  // Actual T12 DWXX reply: transport receipt with an explicit syntax rejection.
  // Match the complete token, not arbitrary prose containing the word ERROR.
  if (/^\(?CMD_END_FLAG_ERROR\)?$/i.test(reply)) return 'rejected';
  if (/(?:^|#)CMD_FAILD$/i.test(reply)) return 'rejected';
  if (/(?:^|#)CMD_SUCCESS$/i.test(reply) && !/(?:^|#)(?:CMD_FAILD|CMD_END_FLAG_ERROR)(?:#|$)/i.test(reply)) return 'command_accepted';
  return fallback;
}
